import React from 'react';
import {useTranslation} from 'react-i18next';
import Icon from '../../../../../../../../../../../../components/icon/index';
import './index.css';

function NewCollaboratorsLoading({collaborators}) {

	const {t} = useTranslation();

	return (
		<div className="new-collaborators-loading">
			<Icon animated={'pulse'}
			      name="spinner" className="mr-2"/>{t('loadingLabelText')} ... {Math.ceil(collaborators.collaborators.length / collaborators.pages.totalRecords * 100)}%
		</div>
	);
}

export default NewCollaboratorsLoading;
